import * as partials from "../partials/types";

export const KLEVENTS = partials.createRequestTypes("KLEVENTS");
export const LOAD_KLEVENTS_LIST = "LOAD_KLEVENTS_LIST";

export * from "../partials/types";
